import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Story from "@/components/Story";
import Footer from "@/components/Footer";
import SiteBackground from "@/components/SiteBackground";
import BioCursor from "@/components/BioCursor";

export default function StoryPage() {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, []);

    return (
        <main
            data-testid="story-page"
            className="relative min-h-screen text-foreground"
        >
            <SiteBackground />
            <BioCursor />
            <Navbar />

            {/* Spacer for fixed navbar */}
            <div className="h-24 md:h-28" />

            <div className="container-x">
                <Link
                    to="/"
                    data-testid="story-back-link"
                    className="inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.22em] text-muted-foreground hover:text-primary transition"
                >
                    <ArrowLeft className="h-4 w-4" />
                    Back to Yaalee
                </Link>
            </div>

            <Story />

            <Footer />
        </main>
    );
}
